import { ATLAS_ASSET_TOKEN_LOCAL_STORAGE_KEY } from "@/modules/atlas-asset-token/constants";
import { AtlasAssetTokenInfo } from "@/modules/atlas-asset-token/types";
import { clearAtlasAssetToken } from "@/modules/atlas-asset-token/clear-token";
import { validationModule } from "@/modules/validation";
import localforage from "localforage";
import { isString } from "lodash-es";

export const getAtlasAssetToken = async (): Promise<AtlasAssetTokenInfo | null> => {
  const result = await localforage.getItem(ATLAS_ASSET_TOKEN_LOCAL_STORAGE_KEY);

  if (!validationModule.objectHasKey(result, "token") || !isString(result.token)) {
    await clearAtlasAssetToken();
    return null;
  }

  const expiresAt = validationModule.objectHasKey(result, "expiresAt")
    ? (result.expiresAt as string | null)
    : null;

  // Check if token is expired
  if (expiresAt) {
    const expiresAtDate = new Date(expiresAt);
    if (expiresAtDate <= new Date()) {
      await clearAtlasAssetToken();
      return null;
    }
  }

  return {
    token: result.token,
    expiresAt,
  };
};
